<div class="navbar-data d-flex flex-xl-row  flex-lg-row flex-md-row flex-sm-column flex-xs-column flex-column   align-items-center justify-content-around p-xl-0 p-lg-0 p-md-3 p-sm-3 p-xs-3 p-3 my-xl-0 mx-xl-0 my-lg-0 mx-lg-0 my-md-3 mx-md-2 my-sm-3 mx-sm-2 my-xs-3 mx-xs-2 my-3 mx-3">

  <div class="d-flex w-100 my-1">
    <div class="col-xl-4  col-lg-4 col-6 px-2 status-card" style="font-size: 12px;">
      <!-- <div style="color:rgb(190, 190, 190)" class="d-flex justify-content-between px-1">
        <div>
        </div>
        <div style="color:rgb(190, 190, 190); text-align: center;">
          <span *ngIf="isMarketActive" class="green">{{"open-market"|translate}}</span>
          <span *ngIf="!isMarketActive" class="red">{{"closed-market"|translate}}</span>
        </div>
      </div> -->
  
      <div class="text-center">
        <div>
          <span class="text-color-theme">EGX</span>
          <img class="mx-1" style="height:20px !important; width: 20px !important; border-radius: 2px;" src="assets/img/eg.svg">
        </div>
        <div>
          <span *ngIf="isMarketActive" class="dot dot-online"></span>
          <span *ngIf="!isMarketActive" class="dot dot-offline"></span>
          <span class="text-muted-special">{{nowDate | date:"dd-MM-YYYY"}}</span><br>
          <span class="text-muted">{{ nowTime$ | async | clockTime: lang : false   }}</span>
        </div>
      </div>
    </div>
  
    <div class="col-xl-8 col-lg-8 col-6 dropdown p-0" *ngIf="egxData!=null">
      <div class="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  class="egx-card mx-2">
        <div class="px-2">
          <div class="d-flex justify-content-between">
            <div class="font-weight-bold index-text-color" style="text-overflow:ellipsis !important;font-size: 14px;white-space: nowrap;overflow: hidden;">
              {{selectedEgx[egxIndex]}}
            </div>
            <div>
              <div *ngIf="egxIndex==0" [ngClass]="egxData.CHANGEPERC30>0? 'green' : 'red'">
                {{egxData.CHANGEVALU30}}
              </div>
              <div *ngIf="egxIndex==1" [ngClass]="egxData.CHANGEPERC70>0? 'green' : 'red'">
                {{egxData.CHANGEVALU70}}
              </div>
              <div *ngIf="egxIndex==2" [ngClass]="egxData.CHANGEPERC100>0? 'green' : 'red'">
                {{egxData.CHANGEVALU100}}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between" style="max-width: 100%;">
            <div class="egxData-value" *ngIf="egxIndex==0" style="text-overflow:ellipsis !important;white-space: nowrap;overflow: hidden;">
              {{egxData.CURRENTVALUE30| number}}
            </div>
  
            <div *ngIf="egxIndex==0" [ngClass]="egxData.CHANGEPERC30>0? 'green' : 'red'">
              {{egxData.CHANGEPERC30| number : '1.2-2'}}
              %
              <i class="ion-md-trending-up" *ngIf="egxData.CHANGEPERC30>0"></i>
              <i class="ion-md-trending-down" *ngIf="egxData.CHANGEPERC30<0"></i>
            </div>
  
            <div class="egxData-value" *ngIf="egxIndex==1" style="text-overflow:ellipsis !important;white-space: nowrap;overflow: hidden;">
              {{egxData.CURRENTVALUE70| number}}
            </div>
  
            <div *ngIf="egxIndex==1" [ngClass]="egxData.CHANGEPERC70>0? 'green' : 'red'">
              {{egxData.CHANGEPERC70| number : '1.2-2'}}
              %
              <i class="ion-md-trending-up" *ngIf="egxData.CHANGEPERC70>0"></i>
              <i class="ion-md-trending-down" *ngIf="egxData.CHANGEPERC70<0"></i>
            </div>
  
            <div class="egxData-value" *ngIf="egxIndex==2" style="text-overflow:ellipsis !important;white-space: nowrap;overflow: hidden;">
              {{egxData.CURRENTVALUE100| number}}
            </div>
  
            <div *ngIf="egxIndex==2" [ngClass]="egxData.CHANGEPERC100>0? 'green' : 'red'">
              {{egxData.CHANGEPERC100| number : '1.2-2'}}
              %
              <i class="ion-md-trending-up" *ngIf="egxData.CHANGEPERC100>0"></i>
              <i class="ion-md-trending-down" *ngIf="egxData.CHANGEPERC100<0"></i>
            </div>
  
  
          </div>
        </div>
      </div>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" (click)="setEgx(0)">EGX30</a>
        <a class="dropdown-item" (click)="setEgx(1)">EGX70</a>
        <a class="dropdown-item" (click)="setEgx(2)">EGX100</a>
      </div>
    </div>
  </div>

  <div class="d-flex w-100 my-1">
    <div class="col-xl-8 col-lg-8 col-6 d-flex p-0 justify-content-around" style="font-size: 14px;" *ngIf="egxData!=null">
      <div class="mx-1 text-center">
        <div class="font-weight-bold" style="color: grey;">
          {{"turnover"|translate}}
        </div>
        <div class="index-data-highlight">
          {{egxData.TURNOVER | number}}<span class="text-muted-special">M</span>
        </div>
      </div>
      <div class="mx-1 text-center">
        <div class="font-weight-bold" style="color: #6c757d;">
          {{'volume'|translate}}
        </div>
        <div class="index-data-highlight">
          {{egxData.VOLUME | number}}<span class="text-muted-special">M</span>
        </div>
      </div>
      <div class="mx-1 text-center">
        <div class="font-weight-bold" style="color: #6c757d;">
          {{"trades"|translate}}
        </div>
        <div class="index-data-highlight">
          {{egxData.TRADES_NUMBER | number}}
        </div>
      </div>
    </div>
  
    <div class="col-xl-4  col-lg-4 col-6  text-center p-0 d-flex flex-column" *ngIf="egxData!=null">
      <div class="d-flex flex-fill align-items-center justify-content-between">
        <small class="text-muted-special" style="width: 40px;">Up</small>
        <div style="width: 70px;">
          <div class="egx-custom" [ngStyle]="{'width':(egxData.ADVANCING/this.totalCalc)*100+'%'}" style="background: rgb(41, 175, 41);">
          </div>
        </div>
        <small class="text-muted-special">{{egxData.ADVANCING}}</small>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-between">
        <small class="text-muted-special" style="width: 40px;">UnCh.</small>
        <div style="width: 70px;">
          <div class="egx-custom" [ngStyle]="{'width':(egxData.UNCHANGED/this.totalCalc)*100+'%'}" style="background:lightslategray"></div>
        </div>
        <small class="text-muted-special">{{egxData.UNCHANGED}}</small>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-between">
        <small class="text-muted-special" style="width: 40px;">Down</small>
        <div style="width: 70px;">
          <div class="egx-custom" [ngStyle]="{'width':(egxData.DECLINING/this.totalCalc)*100+'%'}" style="background: rgb(252, 64, 64);">
          </div>
        </div>
        <small class="text-muted-special">{{egxData.DECLINING}}</small>
      </div>
    </div>
  </div>

</div>
